module.exports = __webpack_public_path__ + "static/img/kb-card-app-contents-03-img-03@w.6302c71.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-app-contents-03-img-03@w.png
// module id = GZUW
// module chunks = 0